<template>
  <LoadingBlock :loading="loading">
    <div class="card mb-4">
      <div class="card-body">
        <div class="row gy-3">
          <div class="col-md-3">
            <input type="text" class="form-control" placeholder="Название товара" v-model="filters.name"
                   @change="search">
          </div>
          <div class="col-md-3">
            <input type="text" class="form-control" placeholder="Бренд" v-model="filters.brand" @change="search">
          </div>
          <div class="col-md-3">
            <Select v-model="filters.product_status_code" :options="productStatusOptions" optionLabel="name"
                    optionValue="code" placeholder="Статус товара" showClear style="width: 100%" @change="search"/>
          </div>
          <div class="col-md-3">
            <Select v-model="selectedCertificate" :options="certificateOptions" optionLabel="label" optionValue="id"
                    placeholder="Сертификат" filter showClear style="width: 100%" @filter="onCertificateFilter"
                    @change="setCertificateFilter"/>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="!items.length" class="text-muted mb-3">Товары не найдены</div>

        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Товар</th>
              <th>Бренд</th>
              <th>Код Ozon</th>
              <th>Сертификаты</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in items" :key="item.offer_id">
              <td>
                <div>{{ item.product_name }}</div>
                <small class="text-muted">{{ item.product_id }}</small>
              </td>
              <td>{{ item.product_brand || '—' }}</td>
              <td>
                <a v-if="item.store_url" :href="item.store_url" target="_blank" rel="noopener noreferrer">
                  {{ item.store_code || item.offer_id }}
                </a>
                <span v-else>{{ item.store_code || item.offer_id }}</span>
              </td>
              <td>
                <div v-if="!item.certificates?.length" class="text-muted">
                  Сертификаты не привязаны
                </div>
                <div v-for="certificate in item.certificates" :key="certificate.certificate_id"
                     class="border rounded p-2 mb-2">
                  <div>
                    <router-link :to="{ name: 'certificate-detail', params: { id: certificate.certificate_id } }">
                      {{ certificate.number }}
                    </router-link>
                  </div>
                  <div class="small">
                    Ozon ID: {{ certificate.ozon_certificate_id || 'не выгружен' }}
                  </div>
                  <div class="small">
                    Статус сертификата:
                    {{ getOzonCertificateStatusLabel(certificate.certificate_status_code) || '—' }}
                  </div>
                  <div class="small">
                    Статус товара:
                    {{ getOzonProductStatusLabel(certificate.product_status_code) || '—' }}
                  </div>
                  <div v-if="certificate.verification_comment" class="small text-muted">
                    {{ certificate.verification_comment }}
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <BasePagination :info="paginationInfo" @changePage="changePage"/>
      </div>
    </div>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import BasePagination from "@/components/list/Pagination.vue";
import {Select} from "primevue";
import {getOzonProducts, getList} from "@/api/certificate";
import {user} from "@/data/user";
import {
    getKindLabel,
    getOzonCertificateStatusLabel,
    getOzonProductStatusLabel,
    ozonProductStatuses,
    parseCertificateError,
} from "@/data/certificate";
import {Message, Messages} from "@/data/messages";

export default {
  name: "CertificateOzonProducts",
  components: {LoadingBlock, BasePagination, Select},
  props: {
    storeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      paginationInfo: {},
      filters: {
        page: 1,
        size: 50,
        name: null,
        brand: null,
        certificate_id: null,
        product_status_code: null,
      },
      selectedCertificate: null,
      certificateOptions: [],
      productStatusOptions: ozonProductStatuses,
      certificateFilterTimeout: null,
    }
  },
  methods: {
    getOzonCertificateStatusLabel,
    getOzonProductStatusLabel,
    buildFilters() {
      return {...this.filters}
    },
    async load() {
      this.loading = true
      try {
        const result = await getOzonProducts(this.storeId, this.buildFilters())
        this.items = result.data.items || []
        this.paginationInfo = {
          total: result.data.total,
          pages: result.data.pages,
          page: result.data.page,
          size: result.data.size,
        }
      } catch (e) {
        this.showError(e)
      }
      this.loading = false
    },
    async search() {
      this.filters.page = 1
      await this.load()
    },
    async changePage(page) {
      this.filters.page = page
      await this.load()
    },
    setCertificateFilter() {
      this.filters.certificate_id = this.selectedCertificate || null
      this.search()
    },
    onCertificateFilter(event) {
      clearTimeout(this.certificateFilterTimeout)
      this.certificateFilterTimeout = setTimeout(() => {
        this.searchCertificates(event.value)
      }, 300)
    },
    async searchCertificates(number = '') {
      const query = {size: 50}
      if (number) {
        query.number = number
      }
      const result = await getList(user.active_company, query)
      this.certificateOptions = (result.data.items || []).map((certificate) => ({
        id: certificate.id,
        label: `${certificate.number} — ${getKindLabel(certificate.kind)}`,
      }))
    },
    showError(e) {
      const message = new Message()
      message.type = 'failure'
      message.text = parseCertificateError(e)
      Messages.list.push(message)
    },
  },
  async mounted() {
    await Promise.all([
      this.searchCertificates(),
      this.load(),
    ])
  },
  watch: {
    storeId() {
      this.filters.page = 1
      this.load()
    },
  },
}
</script>
